// messages
export const INPUT_ASCII_TEXT = 'Invalid characters'
export const INPUT_WHITE_SPACE_TEXT = 'White space should be used within words'
export const INPUT_LIMIT_TEXT = 'Too many characters are provided.'
